import axios from "axios";

export const API_DOMAIN = `${process.env.REACT_APP_BACKEND_URL}`;
export const HEADERS = {
  headers: { "Access-Control-Allow-Origin": API_DOMAIN },
};
// Should replace base url with env variable
const superAgent = axios.create({
  withCredentials: true,
  baseURL: API_DOMAIN,
  timeout: 10000,
});

const dataAgent = axios.create({
  withCredentials: true,
  baseURL: API_DOMAIN,
  timeout: 10000,
});

dataAgent.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error.response);
    if (error.response.status === 401) {
      // window.location.replace("/logout");
      return Promise.reject(error);
    }
  },
);

const Users = {
  getAll: (typeName: string = "") => superAgent.get(`data/${typeName}`),
  // getUser: (id: string | number) => superAgent.get(``),
  create: (typeName: string = "", params: Object) =>
    superAgent.post(`${typeName}/h/create/`, { ...params }),
  update: (typeName: string = "", params: Object) =>
    superAgent.post(`${typeName}/h/update/`, { ...params }),
  delete: (typeName: string = "", params: Object) =>
    superAgent.post(`${typeName}/h/delete/`, { ...params }),
};

const DataType = {
  getAll: (typeName: string = "") => dataAgent.get(`models/${typeName}`),
  get: (typeName: string, id: number | string) =>
    dataAgent.get(`models/${typeName}/${id}`),
  create: (typeName: string = "", params: Object) =>
    dataAgent.post(`models/h/create/`, { ...params, model_name: typeName }),
  update: (typeName: string = "", params: Object) =>
    dataAgent.put(`models/h/update/`, { ...params, model_name: typeName }),
  delete: (params: Object) =>
    dataAgent.delete(`models/h/delete/`, { data: { ...params } }),
  updateSortId: (params: Object) =>
    dataAgent.put(`sort/update/`, { ...params }),
};

const SingleItem = {
  get: (typeName: string) => dataAgent.get(`singleitems/get?name=${typeName}`),
  update: (typeName: string = "", data: Object, rawSchema: string) =>
    dataAgent.post(`singleitems/update/`, {
      name: typeName,
      schema: rawSchema,
      data: JSON.stringify(data),
    }),
  create: (typeName: string = "", data: Object, rawSchema: string) =>
    dataAgent.post(`singleitems/create/`, {
      name: typeName,
      schema: rawSchema,
      data: JSON.stringify(data),
    }),
};

const Models = {
  getAll: () => superAgent.get(`data/models/`),
  publish: (params: Object) => superAgent.put(`/publish/`, params),
};

const Hosting = {
  get: () => superAgent.get(`data/hosting/`),
};

const General = {
  get: () => superAgent.get(`data/general/`),
};

const Auth = {
  login: (params: { name: string; password: string }) =>
    superAgent.post("h/login/", { ...params }, { withCredentials: true }),
  logout: () => superAgent.put("h/logout/", {}, { withCredentials: true }),
  validate: () => superAgent.put("h/validate/", {}, { withCredentials: true }),
  register: (params: {
    name: string;
    password: string;
    email: string;
    user_role: string;
  }) => superAgent.post("h/register/", params, { withCredentials: true }),
  requestResetPassword: (params: { email: string }) =>
    superAgent.put("email_reset_password/", params, {
      withCredentials: true,
    }),
  resetPassword: (params: { new_pw: string; reset_id: string }) =>
    superAgent.post("reset_password/", params, { withCredentials: true }),
  registerMFA: () =>
    superAgent.post("mfa/register", {}, { withCredentials: true }),
  verifyMFA: (mfa_code: number, is_first: boolean) =>
    superAgent.post(
      "mfa/verify",
      { mfa_code, is_first },
      { withCredentials: true },
    ),
  deregisterMFA: () =>
    superAgent.put("mfa/deregister", {}, { withCredentials: true }),
  requestResetMFA: (params: { email: string }) =>
    superAgent.put("mfa/email_reset", params, {
      withCredentials: true,
    }),
  resetMFA: (params: { reset_id: string }) =>
    superAgent.post("mfa/reset", params, { withCredentials: true }),
};

const apiAgent = {
  DataType,
  SingleItem,
  Auth,
  Models,
  Hosting,
  General,
  Users, // TODO: Uncomment to support (admin) users creating users
};

export default apiAgent;
